import { useEffect, useState } from 'react';

const useForceOdinAdmin = () => {
  const [odinAdminOverrideEnabled, setOdinAdminOverrideEnabled] = useState<boolean>(() => {
    try {
      const storedValue = localStorage.getItem('useOdinAdmin');
      return storedValue ? JSON.parse(storedValue) : false;
    } catch (error) {
      console.error('Failed to parse odin admin flag from localStorage', error);
      return false;
    }
  });

  useEffect(() => {
    if (odinAdminOverrideEnabled !== undefined) {
      localStorage.setItem('useOdinAdmin', JSON.stringify(odinAdminOverrideEnabled));
    }
  }, [odinAdminOverrideEnabled]);

  return { odinAdminOverrideEnabled, setOdinAdminOverrideEnabled };
};

export default useForceOdinAdmin;
